export const PageHeader = ({ eyebrow, title, description, actions, testId }) => (
  <div className="mb-10 flex flex-col gap-5 sm:flex-row sm:items-end sm:justify-between" data-testid={testId}>
    <div>
      {eyebrow && <p className="label-caps">{eyebrow}</p>}
      <h1 className="font-display text-3xl sm:text-4xl tracking-tight mt-2">{title}</h1>
      {description && <p className="text-sm text-muted-foreground mt-3 max-w-2xl">{description}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-3">{actions}</div>}
  </div>
);

export const EmptyState = ({ title, hint, action, testId }) => (
  <div className="border border-dashed border-border bg-card px-8 py-16 text-center" data-testid={testId}>
    <p className="font-display text-lg">{title}</p>
    {hint && <p className="text-sm text-muted-foreground mt-2">{hint}</p>}
    {action && <div className="mt-6 flex justify-center">{action}</div>}
  </div>
);

export const Badge = ({ children, className = "", testId }) => (
  <span
    data-testid={testId}
    className={`inline-flex items-center px-2 py-0.5 text-[11px] uppercase tracking-wider font-medium ${className}`}
  >
    {children}
  </span>
);
